import React from 'react'
import logo from './media/codebird_logo.png'
import './header.css';

const Header = () => {
    return (
        <div className='head'>
            <div className='header'>
                <img src={logo} alt="Logo" />
                <div className='desc_title'>
                    <p className='xyz'> H A C K &nbsp; W I Z &nbsp; 1.0 </p>
                    <p className='desc'> Hackathon and Hardware Model Presentation Event</p>
                </div>
            </div>
            <a target="_blank" href='https://forms.gle/CRCtgRENeRUdvTEk9'>REGISTER NOW</a>
        </div>
    )
}

export default Header;